import Grid from "@mui/material/Grid";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { CajasUbicacionList } from "../components/CajasUbicacionList";
import React from 'react';
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import WarehouseIcon from "@mui/icons-material/Warehouse";

export const CajasUbicacion = () => {
  let url = window.location.href;
  let procesoGenerica = false;
  const arrUrl = url.split("/");

  const proceso = arrUrl[arrUrl.length - 1]; // retorna el ultimo valor de la url
  let tituloModulo = "";

  if (proceso === "ubicacion") {
    procesoGenerica = true;
  }

  let parametrosUrl = new URLSearchParams(window.location.search);
  var mudanza = parametrosUrl.get("mudanza");
  var ubicacion_temporal = parametrosUrl.get("ubicacion_temporal");
  var retiro_cajas = parametrosUrl.get("retiro_cajas");
  var devolucion_cajas = parametrosUrl.get("devolucion_caja");
  let ubicacion_caja = false;

  if (mudanza === "1") {
    devolucion_cajas = "0";
    ubicacion_temporal = "0";
    retiro_cajas = "0";
    tituloModulo = "Mudanza de Cajas";
  } else {
    mudanza = "0";
    if (ubicacion_temporal === "1") {
      devolucion_cajas = "0";
      retiro_cajas = "0";
      tituloModulo = "Ubicación Temporal de Cajas";
    } else if (retiro_cajas === "1") {
      devolucion_cajas = "0";
      ubicacion_temporal = "0";
      tituloModulo = "Retiro de Cajas";
    } else if (devolucion_cajas === "1") {
      retiro_cajas = "0";
      ubicacion_temporal = "0";
      tituloModulo = "Devolución de Cajas";
    } else {
      devolucion_cajas = "0";
      retiro_cajas = "0";
      ubicacion_temporal = "0";
      tituloModulo = "Ubicación de Cajas";
      ubicacion_caja = true;
    }
  }
  if (procesoGenerica) {
    tituloModulo = "Ubicación de Cajas Genéricas";
  }

  const datos = {
    valorMudanza: mudanza,
    valorUbicacionTemporal: ubicacion_temporal,
    valorRetiroCaja: retiro_cajas,
    valorDevolucionCaja: devolucion_cajas,
    proceso: proceso,
    procesoGenerica: procesoGenerica,
    ubicacion_caja: ubicacion_caja,
  };

  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title={tituloModulo} icon={<WarehouseIcon />} />
      <CajasProvider>
        <Grid item xs={12} md={12}>
          <CajasUbicacionList datos={datos} />
        </Grid>
      </CajasProvider>
    </Grid>
  );
};
